import { render } from "./FactorGroup.vue?vue&type=template&id=6baf1be4&scoped=true&ts=true"
import script from "./FactorGroup.vue?vue&type=script&lang=ts"
export * from "./FactorGroup.vue?vue&type=script&lang=ts"

import "./FactorGroup.vue?vue&type=style&index=0&id=6baf1be4&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6baf1be4"]])

export default __exports__